import { Log } from '../AuxillaryService/Log';
import { stopCurrentDisplay } from '../Display';
import * as Platform from '../Platform';

export async function signageReload(): Promise<void> {
    const thePlatform = Platform.platform();
    try {
        await stopCurrentDisplay();
    } catch (e) {
        // The original developer failed to document what exception they were
        // trying to catch, so it is unknown why this try/catch block is here.
        //
        // This catch seems unecessary since `stopCurrentDisplay` swallows any error thrown.
    }

    try {
        if (Platform.supportsReload(thePlatform)) {
            await thePlatform.reloadSignage();
        } else if (Platform.supportsPlayerControl(thePlatform)) {
            await thePlatform.rebootSystem();
        } else {
            Log.Error('System Platform Error: features not implemented!', null, __fileline);
        }
    } catch (e) {
        Log.Error('Failed to reload Signage: ' + String(e), null, __fileline);
    }
}
